import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { PrivyKYCStepper } from "../stepper/PrivyKYC";

export default function KYCDialog({ ...props }) {
  const { isOpen, isClose, data } = props;
  const { t } = useTranslation("common");
  return (
    <Dialog fullWidth open={isOpen} onClose={isClose} maxWidth={"sm"}>
      <DialogTitle>
        {t("verification.title")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1.5} sx={{ mt: 1 }}>
              <Grid item xs={12} md={12}>
                <PrivyKYCStepper data={data} isClose={isClose} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
